import moment from 'moment';
import 'moment/locale/ru';
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import { productTypes } from '@fr/constants';

@propsDecorator({
    defaults: {
        selectedIdentity: null,
        subscribed: false,
        hotelInfo: null,
        tourSearchModel: null,
        mapHotelsSearchModel: null,
        tourSearchCriteria: null,

        minPriceBySearchDates: null,
        minPriceOilTaxBySearchDates: null,
        showHotelCashbackBanner: false,
        thereIsToursOffers: false,
    },
})
export default class HotelPageModel extends Backbone.Epoxy.Model {
    initialize() {
        this.initModelEvents();
    }

    initModelEvents() {
        this.on('change:tourSearchModel', (model, tourSearchModel) => {
            tourSearchModel.on('change:syncTourProducts', this.syncTourProductsChanged.bind(this));
            tourSearchModel.on('change:filteredTourProducts', this.syncShowHotelCashbackBanner.bind(this));
        });
    }

    syncShowHotelCashbackBanner(tourSearchModel, filteredTourProducts) {
        const cashbackAvailable = !!filteredTourProducts?.some((tourProduct) => tourProduct?.get('product')?.get('cashbackAvailable'));
        this.set('showHotelCashbackBanner', cashbackAvailable);
    }

    syncTourProductsChanged() {
        const tourSearchModel = this.get('tourSearchModel');
        const syncTourProducts = tourSearchModel.get('syncTourProducts') || [];
        const checkInDateRange = tourSearchModel.get('searchData').get('checkInDateRange');
        const checkInDateRangeFrom = checkInDateRange?.get('from');
        const checkInDateRangeTo = checkInDateRange?.get('to');
        const productType = tourSearchModel.get('filterCriteria')?.get('productType');
        const currentProductType = productType === productTypes.ALL ? productTypes.TOUR_OFFER : productType;

        const selectedDate = moment(checkInDateRangeFrom)
            .format('YYYY-MM-DD');
        const filteredProductsByType = tourSearchModel
            .filterTourProductsByProductTypeWithTourPriority(syncTourProducts, currentProductType);
        const syncTourProductsByCurrentDate = tourSearchModel
            .filterTourProductsByDate(filteredProductsByType.models, selectedDate);

        const thereIsToursOffers = !!syncTourProductsByCurrentDate.find((product) => product.get('tour'));

        let minPriceOilTax = 0;
        let minPrice = 0;

        if (syncTourProducts?.length && checkInDateRangeFrom.getTime() === checkInDateRangeTo.getTime()) {
            const products = syncTourProductsByCurrentDate.length
                ? syncTourProductsByCurrentDate
                : filteredProductsByType;

            const minPricesyncTourProductsByCurrentDate = _.min(products, (tourProduct) => tourProduct?.get('product')?.get('priceWithOilTax')
                ?? tourProduct?.get('product')?.get('price'));

            if (minPricesyncTourProductsByCurrentDate && minPricesyncTourProductsByCurrentDate !== Infinity) {
                minPrice = minPricesyncTourProductsByCurrentDate.get('product')?.get('priceWithOilTax')
                    ?? minPricesyncTourProductsByCurrentDate.get('product').get('price');
                minPriceOilTax = minPricesyncTourProductsByCurrentDate.get('product')?.get('oilTax') || 0;
            }
        } else {
            minPrice = tourSearchModel.get('minPriceSyncTourProducts') || 0;
            minPriceOilTax = tourSearchModel.get('minPriceSyncTourProductsOilTax') || 0;
        }
        //note тут берется цена кнопки для отельной страницы

        this.set('thereIsToursOffers', thereIsToursOffers);
        this.set('minPriceBySearchDates', minPrice);
        this.set('minPriceOilTaxBySearchDates', minPriceOilTax);
    }
}